import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Fire = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22.293 12.851C20.182 11.081 18 9.251 18 3C18 2.448 17.552 2 17 2C16.811 2 16.634 2.054 16.483 2.145C16.483 2.145 13.819 3.774 11.246 6.729C7.814 10.671 6 15.229 6 19.912C6 25.474 10.486 29.999 16 29.999C21.514 29.999 26 25.474 26 19.912C26 15.959 24.116 14.379 22.293 12.851V12.851ZM16 28C13.75 28 12 26.185 12 24.107C12 20.634 13.38 18.278 14.432 16.985C15.052 18.337 16.24 19.338 17.326 20.253C18.761 21.461 20 22.505 20 24.107C20 26.185 18.25 28 16 28ZM21.847 25.424C21.946 25 22 24.56 22 24.107C22 21.575 20.201 20.06 18.614 18.724C17.211 17.542 16 16.522 16 15C16 14.448 15.552 14 15 14C14.775 14 14.568 14.075 14.401 14.2L14.4 14.199C14.22 14.334 10 17.574 10 24.106C10 24.558 10.053 24.998 10.152 25.422C8.818 23.977 8 22.039 8 19.912C8 15.679 9.586 11.701 12.713 8.09C13.931 6.683 15.16 5.608 16.07 4.893C16.515 10.616 18.985 12.688 21.008 14.384C22.745 15.841 24 16.893 24 19.913C24 22.041 23.181 23.979 21.847 25.425V25.424Z" />
	</svg>
);

export default Fire;
